import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import {
  IDataTableAdapter,
  ITableSelectRangeEvent,
  ITableSelectionEvent,
} from '@app/shared/interfaces';
import { ModalLogsComponent } from '../modal-logs/modal-logs.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-table-logs',
  templateUrl: './table-logs.component.html',
  styleUrls: ['./table-logs.component.sass'],
})
export class TableLogsComponent implements OnInit {
  columns: Array<any>;
  modalColumns: Array<any>;
  displayedColumns: Array<any>;
  dataSource = new MatTableDataSource<any>([]);
  serverPagination: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<any>;

  @Input() enablePagination = true;
  @Input() enableSelection = true;
  @Input() selectedAllDefault = false;

  @Input() set dataAdapter(value: IDataTableAdapter) {
    this.buildDataAdpater(value);
  }
  @Output() rowChanged: EventEmitter<ITableSelectionEvent> =
    new EventEmitter<ITableSelectionEvent>();
  @Output() rangeChanged: EventEmitter<ITableSelectRangeEvent> =
    new EventEmitter<ITableSelectRangeEvent>();
  @Output() pageChanged = new EventEmitter<any>();
  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {}

  buildDataAdpater(value: IDataTableAdapter) {
    this.columns = value.columns
      .filter((c) => c.show)
      .map((column: { key: string | number; label: string; ellipsis?: number }) => ({
        columnDef: column.key,
        header: column.label,
        ellipsis: column.ellipsis,
        cell: (element: any) => `${element[column.key] ? element[column.key] : ``}`,
      }));

    this.modalColumns = value.columns;
    this.displayedColumns = this.columns.map((c) => c.columnDef);

    if (value.enableAction) {
      this.displayedColumns.push('action');
    }

    this.dataSource = new MatTableDataSource(value.dataSource);
    this.serverPagination = value.pagination;
  }

  handlePageEvent(e: PageEvent) {
    this.pageChanged.emit({ currentPage: e.pageIndex + 1, pageSize: e.pageSize });
  }

  showLogDetails(log: any) {
    const dataDialog = {
      title: `Detalhes do Log`,
      log,
      columns: this.modalColumns,
    };

    const dialogRef = this.dialog.open(ModalLogsComponent, {
      width: '100%',
      height: '80vh',
      data: dataDialog,
      maxWidth: '80vw',
      panelClass: 'custom-mat-dialog',
    });
  }
}
